import { IconArrowRight, IconEye, IconEyeOff, IconLock, IconRefresh } from "@tabler/icons-preact";
import { useState } from "preact/hooks";
import type { SessionResponse } from "../shared/contracts";
import { apiRequest } from "./api";

interface LoginScreenProps {
  startupError?: string | null;
  onAuthenticated: () => void;
  onRetrySession?: () => void;
}

export function LoginScreen({ startupError, onAuthenticated, onRetrySession }: LoginScreenProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState<string | null>(startupError || null);

  const submit = async (event: SubmitEvent) => {
    event.preventDefault();
    setSending(true);
    setError(null);
    try {
      await apiRequest<SessionResponse>("/api/v1/auth/login", {
        method: "POST",
        body: JSON.stringify({ email, password }),
      });
      onAuthenticated();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "Não foi possível entrar no PowerMail.");
      setSending(false);
    }
  };

  return (
    <main className="login-shell">
      <section className="login-card">
        <div className="login-showcase">
          <div className="login-brand" aria-label="PowerMail">
            <img src="/brand/logo-powermail.jpeg" alt="PowerMail" />
          </div>
        </div>

        <div className="login-access">
          <form className="login-form" aria-label="Acessar o PowerMail" onSubmit={(event) => void submit(event)}>
            <h1 className="sr-only">Acessar o PowerMail</h1>

            <div className="login-fields">
              <label>
                <span>E-mail da conta</span>
                <input
                  type="email"
                  value={email}
                  onInput={(event) => setEmail(event.currentTarget.value)}
                  placeholder="voce@empresa.com.br"
                  autoComplete="username"
                  required
                  autoFocus
                />
              </label>
              <label>
                <span>Senha</span>
                <div className="login-password-field">
                  <IconLock size={17} aria-hidden="true" />
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onInput={(event) => setPassword(event.currentTarget.value)}
                    placeholder="Sua senha de acesso"
                    autoComplete="current-password"
                    minLength={8}
                    maxLength={256}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((visible) => !visible)}
                    aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                  >
                    {showPassword ? <IconEyeOff size={17} aria-hidden="true" /> : <IconEye size={17} aria-hidden="true" />}
                  </button>
                </div>
              </label>
            </div>

            {error ? <p className="form-error" role="alert">{error}</p> : null}

            <button className="button button--primary login-submit" type="submit" disabled={sending}>
              {sending ? "Entrando…" : "Entrar"}
              {sending ? null : <IconArrowRight size={17} aria-hidden="true" />}
            </button>

            {startupError && onRetrySession ? (
              <button className="login-back" type="button" onClick={onRetrySession}>
                <IconRefresh size={15} aria-hidden="true" />
                Tentar verificar novamente
              </button>
            ) : null}
          </form>
        </div>
      </section>
    </main>
  );
}
